<template>
    <h2>No More Members</h2>
    <p>There are no more members to show you at this time.</p>
    <p>Update your <a href="/preferences">preferences</a> to find more matches :)</p>
</template>